<template>
  <el-card shadow="hover">
    <div
      v-if="hasHeaderSlot"
      slot="header"
      class="card-header__wrap">
      <div class="card-header--title">
        <slot name="title"></slot>
      </div>
      <div class="card-header--form">
        <slot name="form"></slot>
      </div>
    </div>
    <div style="margin-bottom: 10px">
      <slot></slot>
    </div>
    <div class="card-footer">
      <slot name="footer"></slot>
    </div>
  </el-card>
</template>
<script>
export default {
  name: 'LayoutCardWrap',
  props: {
    hasHeaderSlot: Boolean
  }
}
</script>
<style lang="stylus" scoped>
.card-header__wrap {
  // padding: 18px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .card-header--form, .card-header--title {
    display: flex;
    align-items: center;
  }
}

.card-footer {
  // margin: 15px 0 0;
  text-align: center;
}
</style>
